import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './CompactHeader.scss';

export const CompactHeader: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="site-header">
        <div className="main-nav">
            <div className="logo-container">
                <Link to="/">
                    <img src="/assets/images/logo.png" alt="Facilon" />
                </Link>
            </div>
            <button className="mobile-menu-btn" onClick={toggleMobileMenu} aria-label="Toggle navigation menu">
                <i className="fa-solid fa-bars"></i>
            </button>
            <div className={`nav-links ${mobileMenuOpen ? 'active' : ''}`} id="navLinks">
                <Link to="/about-us">About Us</Link>
                <Link to="/our-team">Our Team</Link>
                <Link to="/our-expertise">Our Expertise</Link>
                <Link to="/faq">FAQs</Link>
                <Link to="/contact-us">Contact Us</Link>
            </div>
        </div>
    </header>
  );
};
